var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167026",
    "data-name": "Group 167026",
    transform: "translate(-258 -50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167025",
    "data-name": "Group 167025",
    transform: "translate(-29 -142.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_454",
    "data-name": "Line 454",
    d: "M0,12.5A1.5,1.5,0,0,1-1.5,11V0A1.5,1.5,0,0,1,0-1.5,1.5,1.5,0,0,1,1.5,0V11A1.5,1.5,0,0,1,0,12.5Z",
    transform: "translate(290 199.5)",
    fill: "#1c2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_455",
    "data-name": "Line 455",
    d: "M0,10A1,1,0,0,1-1,9V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V9A1,1,0,0,1,0,10Z",
    transform: "translate(295 199.5)",
    fill: "#1c2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_456",
    "data-name": "Line 456",
    d: "M0,12a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V11A1,1,0,0,1,0,12Z",
    transform: "translate(299 199.5)",
    fill: "#1c2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_458",
    "data-name": "Line 458",
    d: "M0,10A1,1,0,0,1-1,9V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V9A1,1,0,0,1,0,10Z",
    transform: "translate(303 199.5)",
    fill: "#1c2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_459",
    "data-name": "Line 459",
    d: "M0,12.5A1.5,1.5,0,0,1-1.5,11V0A1.5,1.5,0,0,1,0-1.5,1.5,1.5,0,0,1,1.5,0V11A1.5,1.5,0,0,1,0,12.5Z",
    transform: "translate(308 199.5)",
    fill: "#1c2023"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayIcon);
export default __webpack_public_path__ + "static/media/pay_icon.b904ca843d4e4c3c4925e3e7601e415d.svg";
export { ForwardRef as ReactComponent };